import { CONFIG } from 'config/config';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const Wrapper = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	width: 90%;

	.title {
		margin-top: 40px;
	}
`;
export const PrimaryWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	border-radius: 3px;
	border: 1px solid ${CONFIG.colors.grey};
`;
export const QuestionnaireBoxWrapper = styled.div`
	width: 100%;
	display: grid;
	gap: ${isMobile ? '10px' : '20px'};
	grid-template-columns: grid-template-columns: repeat(1, minmax(0, 1fr));
	padding: 10px;
	@media (min-width: 768px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
	@media (min-width: 1536px) { 
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
`;
export const QuestionnaireBoxText = styled.p`
	font-size: 15px;
	color: white;
`;

export const QuestionnaireBoxButtonWrapper = styled.div`
	display: flex;
	justify-content: ${isMobile ? 'center' : 'and'};
	align-items: center;
	gap: 20px;
	padding: 10px;
	flex-direction: ${isMobile ? 'column' : 'row'};
`;

export const QuestionnaireBoxButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 65px;
	height: 65px;
	margin: 5px;
	border-radius: 50px;
	background-color: ${(props) => {
		if (props.no) {
			if (props.selected === false) {
				return 'white';
			} else {
				return 'white';
			}
		} else {
			if (props.selected === true) {
				return 'white';
			} else {
				return 'white;';
			}
		}
	}};
	color: ${(props) => {
		if (props.no) {
			if (props.selected === false) {
				return 'white';
			} else {
				return 'white';
			}
		} else {
			if (props.selected === true) {
				return 'white';
			} else {
				return 'white';
			}
		}
	}};
	border: ${(props) => {
		if (props.no) {
			if (props.selected === false) {
				return '0px';
			} else {
				return '1px solid white';
			}
		} else {
			if (props.selected === true) {
				return '0px';
			} else {
				return '1px solid white';
			}
		}
	}};

	outline: none;
	:focus {
		outline: none;
	}
`;
export const QuestionnaireBoxLine = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${CONFIG.colors.grey};
	margin: ${(props) => {
		if (!props.top) {
			return '15px 0px 0px 0px';
		} else {
			return '0px 0px 15px 0px';
		}
	}};
`;
